import { createProvideInject } from '@collector/shared-ui'

import { EventStatusIncidentsOnFieldConfig } from '../configuration'

export const [
  provideEventStatusIncidentsOnFieldConfig,
  injectEventStatusIncidentsOnFieldConfig,
] = createProvideInject<EventStatusIncidentsOnFieldConfig>(
  'eventStatusIncidentsOnFieldConfig',
)
